
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaPrint, FaTag, FaTrash } from "react-icons/fa";



const GenerateBarcode = ({ clientData }) => {
  const client_id = clientData?.id;
  // const client_id = localStorage.getItem("client_id");
const [printItems, setPrintItems] = useState([]);
const [showLabelPreview, setShowLabelPreview] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
const [barcode, setBarcode] = useState("");
const [heading, setHeading] = useState("");
const [field1, setField1] = useState("");
const [field2, setField2] = useState("");
const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    fetchInventory();
  }, []);

const handleAdd = () => {
  setPrintItems([
    ...printItems,
    {
      itemName: selectedItem,
      barcode,
      heading,
      field1,
      field2,
      qty: 1
    }
  ]);
};
const handleDelete = (indexToDelete) => {
  const updatedItems = [...printItems];
  updatedItems.splice(indexToDelete, 1);
  setPrintItems(updatedItems);
};
const printBarcodeItems = (isLabel = false) => {
  if (!printItems.length) {
    alert("Please add at least one item to print.");
    return;
  }

  const printWindow = window.open("", "_blank", "width=1000,height=800");

  if (!printWindow) {
    alert("Please allow popups for this website.");
    return;
  }

  const itemsHtml = printItems
    .flatMap((item) =>
      Array.from({ length: Number(item.qty) || 1 }, () => {
        if (isLabel) {
          return `
            <div class="label">
              <div class="heading">
                ${item.heading || ""}
              </div>

              <img
                src="https://barcode.tec-it.com/barcode.ashx?data=${encodeURIComponent(
                  item.barcode || ""
                )}&code=Code128"
                class="barcode"
                alt="Barcode"
              />

              <div class="fields">
                <span>${item.field1 || ""}</span>
                <span>${item.field2 || ""}</span>
              </div>
            </div>
          `;
        }

        return `
          <div class="a4-item">
            <div class="heading">
              ${item.heading || ""}
            </div>

            <img
              src="https://barcode.tec-it.com/barcode.ashx?data=${encodeURIComponent(
                item.barcode || ""
              )}&code=Code128"
              class="barcode"
              alt="Barcode"
            />

            <div>${item.field1 || ""}</div>
            <div>${item.field2 || ""}</div>
          </div>
        `;
      })
    )
    .join("");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Barcode Print</title>

        <style>
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 20px;
            font-family: Arial, sans-serif;
            background: white;
          }

          .print-container {
            width: 100%;
          }

          /* A4 PRINT */
          .a4-container {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            gap: 20px;
          }

          .a4-item {
            width: 120px;
            text-align: center;
            margin-bottom: 20px;
            page-break-inside: avoid;
          }

          .a4-item .heading {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 5px;
          }

          .a4-item .barcode {
            width: 100px;
            height: auto;
            display: block;
            margin: 0 auto 5px;
          }

          .a4-item div {
            font-size: 13px;
            margin-top: 3px;
          }

          /* LABEL PRINT */
          .label-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }

          .label {
            width: 100%;
            height: 120px;
            border: 1px solid #ddd;
            padding: 8px;
            text-align: center;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            page-break-inside: avoid;
          }

          .label .heading {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 4px;
          }

          .label .barcode {
            width: 100px;
            height: auto;
            display: block;
            margin: 0 auto 3px;
          }

          .fields {
            display: flex;
            justify-content: center;
            gap: 20px;
            font-size: 13px;
            font-weight: 500;
          }

          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          @media print {
            body {
              padding: 0;
            }

            .a4-item,
            .label {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>

        <div class="print-container">
          ${
            isLabel
              ? `<div class="label-container">${itemsHtml}</div>`
              : `<div class="a4-container">${itemsHtml}</div>`
          }
        </div>

      </body>
    </html>
  `);

  printWindow.document.close();

  const printImages = printWindow.document.querySelectorAll("img");

  let loadedImages = 0;

  const startPrint = () => {
    if (loadedImages === printImages.length) {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();

        printWindow.onafterprint = () => {
          printWindow.close();
        };
      }, 300);
    }
  };

  if (printImages.length === 0) {
    startPrint();
  } else {
    printImages.forEach((img) => {
      img.onload = () => {
        loadedImages++;
        startPrint();
      };

      img.onerror = () => {
        loadedImages++;
        startPrint();
      };
    });
  }
};
  const fetchInventory = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
      );

      setInventory(res.data);
    } catch (error) {
      console.log("Error fetching inventory:", error);
    }
  };

  return (
    <div className="container-fluid p-3">
      <div
        className="p-3 mb-3"
        style={{
          background: "#d6e1ef",
          borderRadius: "10px",
        }}
      >
        <h2 className="fw-bold">Generate Barcode</h2>
      </div>

      <div
        className="p-3"
        style={{
          background: "#cfe0f2",
          border: "2px solid #0d4a80",
          borderRadius: "10px",
        }}
      >
        <div className="row">
          <div className="col-md-2 mb-2">
            {/* <label className="fw-bold">Enter Name*</label> */}
            {/* <input
              type="text"
              className="form-control"
              placeholder="Enter Item"
            /> */}
          
  <label className="fw-bold">Enter Name*</label>

 {/* <select
  className="form-select"
  value={selectedItem}
  onChange={(e) => setSelectedItem(e.target.value)}
>
  <option value="">Select Item</option>

  {inventory.map((item) => (
    <option key={item.id} value={item.name}>
      {item.name}
    </option>
  ))}
</select> */}

<select
  className="form-select"
  value={selectedItem}
  onChange={(e) => {
    const itemName = e.target.value;
    setSelectedItem(itemName);

    const selectedProduct = inventory.find(
      (item) => item.name === itemName
    );

    console.log("Selected Product:", selectedProduct);

    if (selectedProduct) {
      setBarcode(selectedProduct.barcode || "");
    } else {
      setBarcode("");
    }
  }}

>
  <option value="">Select Item</option>

  {inventory.map((item) => (
    <option key={item.id} value={item.name}>
      {item.name}
    </option>
  ))}
</select>
          </div>

          <div className="col-md-2 mb-2">
            {/* <label className="fw-bold">Barcode*</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Barcode"
            /> */}
            <label className="fw-bold">Barcode*</label>
            <input
  type="text"
  className="form-control"
  placeholder="Enter Barcode"
  value={barcode}
  onChange={(e) => setBarcode(e.target.value)}
/>
          </div>

          <div className="col-md-2 mb-2">
            <label className="fw-bold">Heading</label>
            {/* <input
              type="text"
              className="form-control"
              placeholder="Heading"
            /> */}
            <input
  type="text"
  className="form-control"
  placeholder="Heading"
  value={heading}
  onChange={(e) => setHeading(e.target.value)}
/>
          </div>

          <div className="col-md-3 mb-2">
            {/* <label className="fw-bold">Field 1</label>
            <input
              type="text"
              className="form-control"
              placeholder="Field 1"
            /> */}
             <label className="fw-bold">Field 1</label>
            <input
  type="text"
  className="form-control"
  placeholder="Field 1"
  value={field1}
  onChange={(e) => setField1(e.target.value)}
/>
          </div>

     <div className="col-md-3 mb-2">
  <label className="fw-bold">Field 2</label>

  <div className="d-flex align-items-center gap-2">
    {/* <input
      type="text"
      className="form-control"
      placeholder="Field 2"
    /> */}
    <input
  type="text"
  className="form-control"
  placeholder="Field 2"
  value={field2}
  onChange={(e) => setField2(e.target.value)}
/>

    <button
  className="btn text-white"
  style={{
    background: "var(--primary-color)",
    whiteSpace: "nowrap",
  }}
  onClick={handleAdd}
>
  Add to Print
</button>
  </div>
</div>
          
        </div>
        
      </div>

     <div
  className="mt-3 table-responsive"
  style={{
    border: "2px solid #0d4a80",
    borderRadius: "10px",
    minHeight: "300px",
  }}
>
 <table
  className="table table-bordered table-hover align-middle mb-0"
  style={{ minWidth: "900px" }}
><thead
  className="text-center"
  style={{
    background: "var(--primary-color)",
    color: "#fff",
    whiteSpace: "nowrap",
  }}
><tr>
  <th style={{ minWidth: "170px" }}>Item Name</th>
  <th style={{ minWidth: "130px" }}>Barcode</th>
  <th style={{ minWidth: "150px" }}>Heading</th>
  <th style={{ minWidth: "170px" }}>Field 1</th>
  <th style={{ minWidth: "170px" }}>Field 2</th>
  <th style={{ minWidth: "120px" }}>No. of Labels</th>
  <th style={{ minWidth: "90px" }}>Delete</th>
</tr>
          </thead>

       <tbody>
  {printItems.map((item, index) => (
    <tr key={index}>
      <td>{item.itemName}</td>
      <td>{item.barcode}</td>
      <td>{item.heading}</td>
      <td>{item.field1}</td>
      <td>{item.field2}</td>
    <td className="text-center">
  <input
    type="number"
    min="1"
    className="form-control mx-auto"
    style={{
      width: "70px",
      textAlign: "center",
    }}
    value={item.qty || 1}
    onChange={(e) => {
      const updatedItems = [...printItems];
      updatedItems[index].qty = Number(e.target.value);
      setPrintItems(updatedItems);
    }}
  />
</td>
     <td>
  <FaTrash
    style={{
      color: "red",
      cursor: "pointer",
      fontSize: "18px",
    }}
    onClick={() => handleDelete(index)}
  />
</td>
    </tr>
  ))}
</tbody>
        </table>
      </div>
      <div
  className="mt-4 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3"
>

      {/* <div className="text-center mt-4"> */}
        {/* <button
          className="btn text-white me-3"
          style={{
            background: "var(--primary-color)",
            borderRadius: "25px",
          }}
        >
          <FaPrint className="me-2" />
          Preview & Print(A4)
        </button> */}
        {/* <button
  className="btn text-white me-3"
  style={{
    background: "var(--primary-color)",
    borderRadius: "25px",
  }}
  onClick={() => setShowPreview(true)}
>
  <FaPrint className="me-2" />
  Preview & Print(A4)
</button> */}<button
  className="btn text-white w-100 w-md-auto"
  style={{
    background: "var(--primary-color)",
    borderRadius: "25px",
    maxWidth: "300px"
  }}
  onClick={() => setShowPreview(true)}
>
  <FaPrint className="me-2" />
  Preview & Print(A4)
</button>

<button
  className="btn text-white w-100 w-md-auto"
  style={{
    background: "var(--primary-color)",
    borderRadius: "25px",
    maxWidth: "300px"
  }}
  onClick={() => setShowLabelPreview(true)}
>
  <FaTag className="me-2" />
  Preview & Print Label(2X(1X2))
</button>
{showPreview && (
  <div
    className="modal d-block"
    style={{ background: "rgba(0,0,0,0.4)" }}
  >
    <div className="modal-dialog modal-xl">
      <div className="modal-content">

     
        <div
          className="p-4"
          id="printArea"
          style={{
            minHeight: "700px",
            background: "#fff"
          }}
        >
          {/* {printItems.map((item, index) => (
            <div
              key={index}
              style={{
                width: "120px",
                textAlign: "center",
                marginBottom: "20px"
              }}
            >
              <div>{item.heading}</div>

              <img
                src={`https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128`}
                alt="barcode"
                width="90"
              />

              <div>{item.field1}</div>
              <div>{item.field2}</div>
            </div>
          ))} */}

          {printItems.flatMap((item, index) =>
  Array.from({ length: item.qty || 1 }, (_, i) => (
    <div
      key={`${index}-${i}`}
      style={{
        width: "120px",
        textAlign: "center",
        marginBottom: "20px",
        display: "inline-block",
        marginRight: "20px"
      }}
    >
      <div>{item.heading}</div>

      <img
        src={`https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128`}
        alt="barcode"
        width="100"
      />

      <div>{item.field1}</div>
      <div>{item.field2}</div>
    </div>
  ))
)}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-danger rounded-pill"
            onClick={() => setShowPreview(false)}
          >
            Cancel
          </button>
          <button
  className="btn btn-danger rounded-pill"
  onClick={() => printBarcodeItems(false)}
>
  Print Now
</button>
{/* 
          <button
            className="btn btn-danger rounded-pill"
            onClick={() => window.print()}
          >
            Print Now
          </button> */}
        </div>

      </div>
    </div>
  </div>
)}

        {/* <button
          className="btn text-white"
          style={{
            background: "var(--primary-color)",
            borderRadius: "25px",
          }}
        >
          <FaTag className="me-2" />
          Preview & Print Label(2X(1X2))
        </button> */}
        {/* <button
  className="btn text-white"
  style={{
    background: "var(--primary-color)",
    borderRadius: "25px",
  }}
  onClick={() => setShowLabelPreview(true)}
>
  <FaTag className="me-2" />
  Preview & Print Label(2X(1X2))
</button> */}
{showLabelPreview && (
  <div className="modal d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
    <div className="modal-dialog modal-xl">
      <div className="modal-content">

        <div
          className="p-4"
          style={{
            minHeight: "700px",
            background: "#fff",
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            gap: "20px"
          }}
        >
          {printItems.flatMap((item, index) =>
            Array.from({ length: item.qty || 1 }, (_, i) => (
              <div
  key={`${index}-${i}`}
  style={{
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "center",
    height: "120px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }}
>
  
  <div
    style={{
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "4px"
    }}
  >
    {item.heading}
  </div>


  <img
    src={`https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128`}
    alt=""
    width="100"
    style={{ alignSelf: "center" }}
  />

 
<div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "20px",     
    marginTop: "-5px",
    fontSize: "13px",
    fontWeight: "500"
  }}
>
  <span>{item.field1}</span>
  <span>{item.field2}</span>
</div>
</div>
            ))
          )}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-danger rounded-pill"
            onClick={() => setShowLabelPreview(false)}
          >
            Cancel
          </button>
<button
  className="btn btn-danger rounded-pill"
  onClick={() => printBarcodeItems(true)}
>
  Print Now
</button>
          {/* <button
            className="btn btn-danger rounded-pill"
            onClick={() => window.print()}
          >
            Print Now
          </button> */}
        </div>

      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default GenerateBarcode;